module.exports = __webpack_public_path__ + "media/images/costumes/top/dress/thumbnail-4-71f17fc3d9d44cb2e286fddcf8ab7847.jpg";